import React from 'react';
import ContentWrapper from '../lib_react_adminlte/componentes/ContentWrapper.jsx';
import Box from '../lib_react_adminlte/componentes/Box.jsx';
import Api from '../utils/Api.jsx';
import { getNomeMes } from '../utils/utils';

export default class Empresa extends React.Component {

  state = {
    empresa: {},
    fechamentos: [],
  }

  async componentWillMount() {
    const pathsUrl = window.location.href.split('/');
    const cnpj = pathsUrl[pathsUrl.length - 1];
    await this.carregar(cnpj);
  }
  
  async carregar(cnpj) {
    const ret = await Api.getDadosEmpresaFechamento(cnpj);
    if (!ret.status) {
      // console.log(ret);
      return;
    }
    this.setState({ empresa: ret.dados.empresa, fechamentos: ret.dados.fechamentos });
  }
  
  renderMeses(dados) {
    return dados.map(x => (
      <div  className="campoDownload m-0">
        <span className='fs-20 wx-100 fl block'>
        {getNomeMes(x.mes)}</span> <a target='blank' href={x.link_download_direto}>
          {x.nome_arquivo}
        </a>   
        <span style={{float:'right'}}> {x.hora_recebimento}</span>

      </div>
    ));
  }

  render() {  
    return (
      <ContentWrapper title={this.state.empresa.nome_fantasia}
                      small={this.state.empresa.razao_social}
                      style={{overflow:'scroll'}}>
        {this.state.fechamentos.map(x => (
          <Box collapsible title={x.ano} className="m-0">
            {this.renderMeses(x.meses)}
          </Box>
        ))}
      </ContentWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/componentes/Empresa.jsx